<template>
    <div class="newPage">
        <div class="content">
            <div class="VOCNavBar">
                <div class="navBarItem">
                    <div class="navBarTitle">开始日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">结束日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="title">选择模块</div>
                <div class="statisticBox scrollbar">
                    <el-radio-group v-model="queryParams.moduleId" @change="ModuleChange">
                        <div v-for="(item,index) in moduleList" :key="index">
                            <el-radio :label='item.id'>{{item.name}}</el-radio>
                        </div>
                    </el-radio-group>
                </div>
                <div class="title">选择城市及站点</div>
                <div class="statisticBox scrollbar cityAndStation" v-loading="cityLoading">

                    <template v-if="queryParams.ModuleType==1">
                        <div class="item">
                            <el-radio-group v-model="queryParams.city" @change="cityChange">
                                <div v-for="(item,index) in query.citys" :key="index">
                                    <el-radio :label='item.city'>{{item.city}}</el-radio>
                                </div>
                            </el-radio-group>
                        </div>
                        <div class="item">
                            <el-checkbox-group v-model="queryParams.stations">
                                <div v-for="(item,index) in query.stations" :key="index">
                                    <el-checkbox :label='item.station' v-if="queryParams.city===item.city">
                                        {{item.station}}
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </template>
                    <template v-if="queryParams.ModuleType==2">
                        <div class="item">
                            <el-cascader
                                    v-model="queryParams.cityName"
                                    :options="cityList"
                                    :props="cityProps"
                                    clearable
                                    size="mini"
                            ></el-cascader>
                        </div>
                    </template>

                </div>
                <div class="btnBox">
                    <el-button type="primary" size="mini" @click="getList">查询</el-button>
                    <el-button type="primary" size="mini" @click="getPDF">生成报告</el-button>
                    <el-button type="primary" size="mini" @click="reportDown" :disabled="!isgetReport">下载报告</el-button>
                    <el-button type="primary" size="mini" @click="excelExport" :disabled="!isgetData">导出</el-button>
                </div>
                <!--<el-tree-->
                <!--:data="data"-->
                <!--show-checkbox-->
                <!--node-key="id"-->
                <!--:default-expanded-keys="[2, 3]"-->
                <!--:default-checked-keys="[5]">-->
                <!--</el-tree>-->
            </div>
            <div class="showContent" v-loading="loading">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-if="tableData && isShowTabel ">
                    <el-table
                            size="mini"
                            :data="tableData.list"
                            border
                            style="width: 100%">
                        <el-table-column
                                fixed
                                prop="station"
                                label="站点名称"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="startTime"
                                label="开始时间"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="endTime"
                                label="结束时间"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                v-for="(item,index) in queryList"
                                :key="index"
                                :prop="item.mname"
                                :label="item.name"
                        >
                        </el-table-column>

                    </el-table>

                    <pagination
                            v-show="tableData.totalCount>0"
                            :total="tableData.totalCount"
                            :page.sync="queryParams.page"
                            :limit.sync="queryParams.pageSize"
                            @pagination="getList"
                    />
                </div>
                <div v-if="!isShowTabel">
                    <!--<div class="btnBox" style="text-align: right">-->
                    <!--<el-button type="primary" size="mini" @click="getMod">编辑模板</el-button>-->
                    <!--</div>-->
                    <pdf v-for="i in numPages" :key="i" :src="src" :page="i" ref="myPdfComponent"></pdf>
                </div>
            </div>
        </div>

        <el-dialog
                title="提示"
                :visible.sync="open"
                width="90%"
                :before-close="handleClose">
            <div>
                <editor v-model="wordtemplate"></editor>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="open = false">取 消</el-button>
                <el-button type="primary" @click="saveTemplate">修改模板</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import Breadcrumb from "../../../components/breadcrumb";

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }


    import url from "../../../utils/UrlApi"
    // import pdf from 'vue-pdf'
    import pdf from '../../../components/vue-pdf'
    import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
    import Editor from "../../../components/Editor/index";

    export default {
        name: "reportAnalysis",
        components: {Editor, Breadcrumb, pdf},
        computed: {
            id: {
                get() {
                    return this.$route.query.id
                }
            }
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                queryParams: {
                    city: '',
                    stations: [],
                    cityName: [],
                    type: 2,
                    page: 1,
                    pageSize: 10,
                    moduleId: '',
                    ModuleType: 0
                },

                tableData: null,
                queryList: null,
                query: {},
                pdfUrl: "",
                src: '',
                numPages: 0,
                page: 1,
                currentPage: 0,
                isShowTabel: true,
                loading: false,
                moduleList: [],
                props: {
                    multiple: true,
                    label: 'name',
                    value: 'name'
                },
                isgetData: false,  //  是否查询数据
                isgetReport: false,  //  是否生成报告

                open: false,
                wordtemplate: '',
                cityList: [],
                cityProps: {
                    multiple: false,
                    emitPath: true,
                    label: "lable",
                    value: "lable"
                },
                cityLoading: false,
            }
        },
        created() {
            this.getMapping()
            this.getmodule()
            this.getqueryList()
            this.getCityList()
        },
        methods: {
            init() {
                this.queryParams = {
                    city: '',
                    stations: [],
                    type: 2,
                    page: 1,
                    pageSize: 10,
                    ModuleType: 0,
                    cityName: []

                }
                this.tableData = null
                this.isShowTabel = true
                this.getmodule()
            },
            getList() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.stations = this.queryParams.stations.join()

                if (!data.moduleId) {
                    return this.$message.error('请选择模块')
                }
                if (!data.startTime) {
                    return this.$message.error('请选择开始时间')
                }
                if (!data.endTime) {
                    return this.$message.error('请选择结束时间')
                }

                if (this.queryParams.cityName && this.queryParams.cityName.length > 0) {
                    data.city = this.queryParams.cityName[this.queryParams.cityName.length - 1]
                    data.cityName = ''
                }

                this.loading = true
                this.$http.get(url.ocecMetallist, {
                    params: data
                }).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        this.isShowTabel = true
                        this.tableData = res.data.data
                        this.isgetData = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getMapping() {
                let data = {}
                this.$http.get(url.ocecMetalmapping, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.queryList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            cityChange(node) {
                // console.log(node)

                //  每次切换 城市,重置站点数据
                this.queryParams.stations = []
            },
            ModuleChange(node) {
                this.cityLoading = true
                let data = {
                    id: node
                }
                //     查询模块类型
                this.$http.get(url.wordTemplatemoduleType, {
                    params: data
                }).then(res => {
                    this.cityLoading = false
                    if (res.data.code === '200') {
                        this.queryParams.ModuleType = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },

            //  查询城市树
            getCityList() {
                let data = {}
                this.$http.get(url.addressAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  下载
            reportDown() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.token = localStorage.getItem('token')
                data.stations = this.queryParams.stations.join()
                if (this.queryParams.cityName && this.queryParams.cityName.length > 0) {
                    data.city = this.queryParams.cityName[this.queryParams.cityName.length - 1]
                    data.cityName = ''
                }
                if (!data.startTime) {
                    return this.$message.error('请选择开始时间')
                }
                if (!data.endTime) {
                    return this.$message.error('请选择结束时间')
                }
                let allUrl = url.analysisReportparticulates + params(data)
                window.open(allUrl, '_blank')
            },


            getPDF() {
                let da
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.stations = this.queryParams.stations.join()

                if (!data.moduleId) {
                    return this.$message.error('请选择模块')
                }
                if (!data.startTime) {
                    return this.$message.error('请选择开始时间')
                }
                if (!data.endTime) {
                    return this.$message.error('请选择结束时间')
                }
                if (this.queryParams.cityName && this.queryParams.cityName.length > 0) {
                    data.city = this.queryParams.cityName[this.queryParams.cityName.length - 1]
                    data.cityName = ''
                }

                this.loading = true
                this.$http.get(url.analysisReportparticulatesPdf, {
                    params: data
                }).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        da = res.data.message
                        let datas = 'data:application/pdf;base64,' + da
                        this.src = pdf.createLoadingTask({url: datas, CMapReaderFactory});
                        this.src.promise.then(pdf => {
                            this.numPages = pdf.numPages;
                        });
                        this.isShowTabel = false

                        this.isgetReport = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getqueryList() {
                let data = {}
                this.$http.get(url.analysisReportcitys, data).then(res => {
                    if (res.data.code === '200') {
                        this.query = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getmodule() {
                let data = {
                    id: this.id
                }
                this.$http.get(url.analysisReportlist, {params: data}).then(res => {
                    this.moduleList = res.data.data
                })
            },
            //  导出
            excelExport() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.token = localStorage.getItem('token')
                data.stations = this.queryParams.stations.join()
                if (this.queryParams.cityName && this.queryParams.cityName.length > 0) {
                    data.city = this.queryParams.cityName[this.queryParams.cityName.length - 1]
                    data.cityName = ''
                }
                if (!data.startTime) {
                    return this.$message.error('请选择开始时间')
                }
                if (!data.endTime) {
                    return this.$message.error('请选择结束时间')
                }
                let allUrl = url.ocecMetalexport + params(data)
                window.open(allUrl, '_blank')
            },


            getMod() {
                let data = {
                    moduleId: this.queryParams.moduleId
                }
                this.$http.get(url.wordtemplate, {params: data}).then(res => {
                    // console.log(res)
                    this.wordtemplate = res.data.message
                    this.open = true
                })

            },

            saveTemplate() {
                let data = {
                    moduleId: this.queryParams.moduleId,
                    html: this.wordtemplate
                }
                this.$http.post(url.wordtemplateWrite, data).then(res => {
                    console.log(res)
                    // this.wordtemplate = res.data.message
                    // this.open = true
                })
            },

            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            }
        },
        beforeRouteUpdate(to, from, next) {
            //     路由切换
            //     初始化页面
            next()
            this.init()
        },
    }
</script>

<style scoped lang="less">
    @import "../../../assets/vocContent";

    .cityAndStation {
        display: flex;
        .item {
            flex: 1;
            border-right: 1px solid #ddd;
            padding: 4px;
        }
        .item:last-child {
            border-right: 0;
        }
    }

    .dialog-footer {
        margin: 20px 0;
    }
</style>
